import { render, staticRenderFns } from "./DetailUjianPerProgram.vue?vue&type=template&id=54371975"
import script from "./DetailUjianPerProgram.vue?vue&type=script&lang=js"
export * from "./DetailUjianPerProgram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports